export default __webpack_public_path__ + "static/media/ibond-universal.df1cdbad.png";